export default __webpack_public_path__ + "static/media/sick_status.981e7621.svg";